// https://www.algolia.com/doc/api-reference/widgets/hits/js/#templates

import algoliasearch from 'algoliasearch';
import instantsearch from 'instantsearch.js';
import * as instantsearchWidgets from 'instantsearch.js/es/widgets';
import algoliaRecommend from '@algolia/recommend';
import debounce from 'lodash.debounce';
import {
    getUrlParameter,
    hasUrlParameter,
    isHeaderDesktopScreenSize,
    toggleHeaderSearchBackground,
    setCookie,
    getCookie,
    forceString,
    hpaAlgoliaEvent,
    getCurrenLocaleObj
} from "../functions";
// https://www.algolia.com/doc/api-reference/widgets/infinite-hits/js/#widget-param-cache
// We provide another implementation which uses sessionStorage, which is more persistent and lets you restore the scroll position when you leave and come back to the search page.
// import { createInfiniteHitsSessionStorageCache } from 'instantsearch.js/es/lib/infiniteHitsCache';

var algoliaFacetFilters = [];

$(function() {
    const algoliaAppID = 'MWM0VGEMN0',
        algoliaSearchAPIKey = 'a19fb64b755e511f7574d6b0a2f7a107',
        currenLocaleObj = getCurrenLocaleObj();

    let currentLocale = currenLocaleObj.locale;
    const searchResultsUrlPath = currenLocaleObj.urlPrefix + '/search/results/';
    const relevanceFirstRanking = ['typo', 'geo', 'words', 'proximity', 'attribute', 'exact', 'filters', 'custom'];

    let mainInstantsearch = false,
        searchBoxPlaceholder = hpaTranslatedtext.algoliaSearch.general.searchBoxPlaceholder, // Search...
        page = '';
    if ($('.ArchivedWebinarHolder').length) {
        page = 'ArchivedWebinarHolder';
        searchBoxPlaceholder = hpaTranslatedtext.algoliaSearch.archivedWebinarHolder.searchBoxPlaceholder; // Search by topic or keyword...
    } else if ($('.CalculatorHolderPage').length) {
        page = 'CalculatorHolderPage';
        searchBoxPlaceholder = hpaTranslatedtext.algoliaSearch.calculatorHolderPage.searchBoxPlaceholder; // Search by topic or keyword...
    } else if ($('.QAndAVideoHolder').length) {
        page = 'QAndAVideoHolder';
        searchBoxPlaceholder = hpaTranslatedtext.algoliaSearch.archivedWebinarHolder.searchBoxPlaceholder; // Search by topic or keyword...
    } else if ($('.ForumHolder').length) {
        searchBoxPlaceholder = hpaTranslatedtext.algoliaSearch.forumHolder.searchBoxPlaceholder; // Search Posts...
    } else if ($('.PodcastHolderPage').length) {
        page = 'PodcastHolderPage';
        searchBoxPlaceholder = hpaTranslatedtext.algoliaSearch.podcastHolderPage.searchBoxPlaceholder; // Search Podcasts...
    }
    let indexNamePrefix = 'live';
    if (window.location.host === 'lh.hpacademy.com' || window.location.host === 'lh.hpacademy.com:8888' || window.location.host === 'beta.hpacademy.com') {
        // indexNamePrefix = 'dev';
    }

    let indexName = indexNamePrefix + '_HPA',
        hasSearchedFromQuery = false,
        query = '',
        resetSearchResultsPage = false;
    var algoliaLastSearchQuery = '';

    const algoliaRecommendClient = algoliaRecommend(algoliaAppID, algoliaSearchAPIKey),
        algoliaRecommendCurrentObjectID = (typeof currentAlgoliaObjectID !== 'undefined' ? currentAlgoliaObjectID : false),
        $algoliaRecommend = $('.algolia-recommend'),
        $algoliaRecommendItems = $algoliaRecommend.find('.items');

    if ($algoliaRecommend.length && algoliaRecommendCurrentObjectID) {
        // console.log({algoliaRecommendCurrentObjectID, indexName, UserToken: getCookie('HpaAlgoliaUserToken')});

        algoliaRecommendClient.getRelatedProducts([
            {
              indexName: indexName,
              objectID: algoliaRecommendCurrentObjectID,
              maxRecommendations: 4,
            },
          ])
          .then(({ results }) => {
            // console.log(results[0].hits);

            const hits = ($.isArray(results) && $.isArray(results[0].hits) ? results[0].hits : false);
            let html = ``;

            if (hits) {
                hits.forEach(item => {
                    const objectExtraData = (item.objectExtraData && Object.keys(item.objectExtraData).length ? item.objectExtraData : false),
                        isCourseOrPackage = (item.objectGroupID === 'Course' || item.objectGroupID === 'Package' ? true : false),
                        isForumPost = (item.objectGroupID === 'Forum_Post' ? true : false),
                        isCourseComponent = (item.objectGroupID === 'Course_Module' ? true : false),
                        isArticleOrBlogPost = (item.objectGroupID === 'Tech_Article' || item.objectGroupID === 'Blog_Post' ? true : false);
                    let courseIsOwned = false;

                    if (item.objectClassName === 'hpa\\mysite\\CourseEntry') {
                        if (gtmMemberData !== false) {
                            gtmMemberCourses.forEach(function(course, index, array) {
                                if (course.course_id == item.objectSilverstripeID) {
                                    courseIsOwned = true;
                                }
                            });
                        }
                    }

                    let objectExtraDataHtml = ``;
                    if (objectExtraData) {
                        objectExtraDataHtml += `<ul class="points">`;
                        if (item.objectClassName === 'hpa\\mysite\\CourseEntry') {

                            if ('ModulesCount' in objectExtraData) {
                                if (objectExtraData.ModulesCount) {
                                    objectExtraDataHtml += `<li><span>${objectExtraData.ModulesCount}</span></li>`;
                                }
                            }
                            if ('CompetencyLevel' in objectExtraData) {
                                if (objectExtraData.CompetencyLevel) {
                                    objectExtraDataHtml += `<li><span>${objectExtraData.CompetencyLevel}</span></li>`;
                                }
                            }
                            if ('StudentsEnrolledCount' in objectExtraData) {
                                if (objectExtraData.StudentsEnrolledCount) {
                                    objectExtraDataHtml += `<li><span>${objectExtraData.StudentsEnrolledCount}</span></li>`;
                                }
                            }

                        } else if (item.objectClassName === 'hpa\\mysite\\ArchivedWebinar' || item.objectClassName === 'hpa\\mysite\\QAndAVideoPage') {

                            if ('VideoDuration' in objectExtraData) {
                                if (objectExtraData.VideoDuration) {
                                    objectExtraDataHtml += `<li><span>${objectExtraData.VideoDuration}</span></li>`;
                                }
                            }

                        } else if (item.objectClassName === 'SilverStripe\\Blog\\Model\\BlogPost' || item.objectClassName === 'hpa\\mysite\\TechArticle') {

                            // if ('EstimatedReadingTime' in objectExtraData) {
                            //     if (objectExtraData.EstimatedReadingTime) {
                            //         objectExtraDataHtml += `<li><span>${objectExtraData.EstimatedReadingTime}</span></li>`;
                            //     }
                            // }

                        } else if (isCourseComponent) {

                            if ('CourseTitle' in objectExtraData) {
                                if (objectExtraData.CourseTitle) {
                                    objectExtraDataHtml += `<li><span>${objectExtraData.CourseTitle}</span></li>`;
                                }
                            }

                            if ('StudentsEnrolledCount' in objectExtraData) {
                                if (objectExtraData.StudentsEnrolledCount) {
                                    objectExtraDataHtml += `<li><span>${objectExtraData.StudentsEnrolledCount}</span></li>`;
                                }
                            }

                        }
                        objectExtraDataHtml += `</ul>`;
                    }

                    let groupID = item.objectGroupID,
                        title = item.objectTitle,
                        imageURL = (item.objectImage ? item.objectImage : '/resources/themes/base/production/images/no-image-400x220.png');
                    if (title.toLowerCase().includes('[podcast]')) {
                        // title = title.replace(/\[podcast\]/i, '');
                        groupID = 'Podcast';
                    }

                    html += `<a href="${item.objectLink}" class="item">`;
                        html += `<span class="label" data-type="${groupID}"></span>`;
                        html += `<div class="image${item.objectImage ? '' : ' no-image'}">`;
                            html += `<img src="${imageURL}" alt="${title}" />`;
                        html += `</div>`;
                        html += `<div class="title">${title}</div>`;
                        // if (isArticleOrBlogPost) {
                            html += `<p>${item._snippetResult.objectContent.value}</p>`;
                        // } else {
                            html += `${objectExtraDataHtml}`;
                        // }
                    html += `</a>`;
                });

                $algoliaRecommendItems.append(html);
                $algoliaRecommend.addClass('populated');
            }
          })
          .catch(err => {
            console.log(err);
          });
    }

    // const testNull = null,
    //     testUndefined = undefined,
    //     testInt = 1984,
    //     testFloat = 101.99,
    //     testString = 'my test string',
    //     testBooleanTrue = true,
    //     testBooleanFalse = false,
    //     testObject = {
    //         testNull, testUndefined, testInt, testFloat, testString, testBooleanTrue, testBooleanFalse
    //     };
    // console.log(typeof testFloat);
    // console.log(testObject);
    // console.log({
    //     testNull: forceString(testNull),
    //     testUndefined: forceString(testUndefined),
    //     testInt: forceString(testInt),
    //     testFloat: forceString(testFloat),
    //     testString: forceString(testString),
    //     testBooleanTrue: forceString(testBooleanTrue),
    //     testBooleanFalse: forceString(testBooleanFalse),
    //     testObject: forceString(testObject),
    // });

    // const algoliaUserTokenCookieName = 'HpaAlgoliaUserToken',
    //     algoliaUserTokenLocalStorageName = 'algoliaUserToken';
    // let algoliaUserToken = '',
    //     gtmMemberDataAlgoliaUserToken = '',
    //     cookieAlgoliaUserToken = forceString(getCookie(algoliaUserTokenCookieName)),
    //     setAlgoliaUserTokenCookie = false;
    //
    // if (typeof gtmMemberData === 'object' && gtmMemberData.algolia_user_token && gtmMemberData.algolia_user_token.length) { // Member is logged in
    //     algoliaUserToken = forceString(gtmMemberData.algolia_user_token);
    //     gtmMemberDataAlgoliaUserToken = algoliaUserToken;
    // } else if (cookieAlgoliaUserToken.length) {
    //     algoliaUserToken = cookieAlgoliaUserToken;
    // }
    // if (algoliaUserToken !== '' && cookieAlgoliaUserToken !== algoliaUserToken) {
    //     setAlgoliaUserTokenCookie = true;
    // }
    //
    // if (algoliaUserToken === '') {
    //     algoliaUserToken = uuidv4();
    //     // if they have it stored in localStorage then we need to migrate them to the new cookie
    //     let lsAlgoliaUserToken = forceString(window.localStorage.getItem(algoliaUserTokenLocalStorageName));
    //     if (lsAlgoliaUserToken.length) {
    //         algoliaUserToken = lsAlgoliaUserToken;
    //         window.localStorage.removeItem(algoliaUserTokenLocalStorageName);
    //         setAlgoliaUserTokenCookie = true;
    //     }
    // }
    //
    // // console.log({algoliaUserToken});
    // if (algoliaUserToken && setAlgoliaUserTokenCookie) {
    //     // console.log('setting cookie');
    //     setCookie(algoliaUserTokenCookieName, algoliaUserToken, 10950);
    // }
    //
    // // console.log({gtmMemberDataAlgoliaUserToken});
    // if (algoliaUserToken !== '' && gtmMemberData && gtmMemberDataAlgoliaUserToken === '') {
    //     // console.log('get /algolia/smaut');
    //     // Set Member's Algolia User Token
    //     $.get('/algolia/smaut', '', function(data) {
    //         // console.log(data);
    //     }, 'json');
    // }

    // if (window.GtmDefined) {
    //     window.dataLayer.push({
    //         algoliaIndexName: indexName
    //     });
    //
    //     let algoliaUserToken = '';
    //     if (typeof gtmMemberData === 'object') {
    //         algoliaUserToken = gtmMemberData.user_id;
    //         window.localStorage.setItem('algoliaUserToken', algoliaUserToken); // So it can be used even if they are not loggec in next time
    //     } else {
    //         algoliaUserToken = window.localStorage.getItem('algoliaUserToken');
    //         if (!algoliaUserToken) {
    //             algoliaUserToken = Date.now().toString(36) + Math.random().toString(36).substr(2);
    //             window.localStorage.setItem('algoliaUserToken', algoliaUserToken);
    //         }
    //     }
    //
    //     if (algoliaUserToken != '') {
    //         window.dataLayer.push({
    //             algoliaUserToken: algoliaUserToken // the userToken of the current visitor to uniquely identify them
    //         });
    //     }
    // }

    // const sendAlgoliaDisplayedObjectIDs = function() {
    //     const items = $('.prev-webinar-inner');
    //     if (items.length) {
    //         const objectIDs = [];
    //         items.each(function() {
    //             const $this = $(this);
    //             let objectID = $this.data('insights-object-id');
    //             if (objectID != '') {
    //                 objectIDs.push(objectID);
    //             }
    //         });
    //
    //         if (objectIDs != '') {
    //             if (window.GtmDefined) {
    //                 window.dataLayer.push({
    //                     algoliaDisplayedObjectIDs: objectIDs
    //                 });
    //             }
    //         }
    //     }
    // };

    const algoliaSendQueryToGA = debounce(function(query) {
        if (query && algoliaLastSearchQuery !== query) {
            algoliaLastSearchQuery = query;
            let gaPageViewValue = window.location.pathname + '?q=' + query;
            // console.log('sending GA event', gaPageViewValue);
            if (window.GoogleAnalyticsDefined) {
                ga('send', 'pageview', gaPageViewValue);
            }
        }

        // sendAlgoliaDisplayedObjectIDs();
    }, 100);


    if ($('#algolia-search-box').length || $('#algolia-header-search-box').length || $('#algolia-dropdown-search-box').length) {
        var searchClient = algoliasearch(algoliaAppID, algoliaSearchAPIKey);
        var template = {
            item: `
              <a href="{{ objectLink }}" class="algolia-object" data-object-id="{{objectID}}" data-hit-index="{{__hitIndex}}" data-position="{{__position}}" data-query-id="{{__queryID}}">
                {{#helpers.highlight}}{ "attribute": "objectTitle" }{{/helpers.highlight}}
              </a>
              <p>{{#helpers.snippet}}{ "attribute": "objectContent" }{{/helpers.snippet}}</p>
            `, // No results for <q>{{ query }}</q>
            empty: hpaTranslatedtext.algoliaSearch.resultsPage.noResultsForQuery,
        };
        // https://www.algolia.com/doc/api-reference/widgets/hits/js/#templates
        var templatesArchivedWebinars = {
            item: `
                <div class="prev-webinar-inner algolia-object" data-object-id="{{objectID}}" data-hit-index="{{__hitIndex}}" data-position="{{__position}}" data-query-id="{{__queryID}}">
                    <div class="equal article-info">
                        <div class="video-mask">
                            <a href="{{ objectLink }}">
                                <img src="{{ objectImage }}" alt=""/>
                                <span class="play-arrow">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="200 0.5 561.9 559.5" class="svg-play"><path d="M752.5 268.8L218.7 1.9c-3.7-1.9-9.3-1.9-13.1 0-3.7 1.9-5.6 5.6-5.6 11.2V547c0 3.7 1.9 7.5 5.6 11.2 1.9 1.9 3.7 1.9 7.5 1.9 1.9 0 3.7 0 5.6-1.9l535.7-266.9c3.7-1.9 7.5-5.6 7.5-11.2-1.9-3.8-3.8-9.4-9.4-11.3z"></path></svg>
                                </span>
                            </a>
                        </div>
                        <div class="title">
                            <h3><a href="{{ objectLink }}">{{#helpers.highlight}}{ "attribute": "objectTitle" }{{/helpers.highlight}}</a></h3>
                        </div>
                    </div>
                    <a class="read-more" href="{{ objectLink }}">Watch Now <svg xmlns="http://www.w3.org/2000/svg" viewBox="233.6 134.4 492.8 291.2" class="svg-arrow-right"><path d="M578.9 134.4l-26.1 26.1 102.7 102.7H233.6v37.3h421.9l-99 99 26.2 26.1 143.7-143.7z"></path></svg></a>
                </div>
            `,
            empty: hpaTranslatedtext.algoliaSearch.archivedWebinarHolder.noResults, // No lessons were found for your search
            showMoreText: hpaTranslatedtext.algoliaSearch.archivedWebinarHolder.showMore, // Show More
        };

        var templatesCalculatorPages = {
            item: `
                <a href="{{ objectLink }}" class="{{#objectImage}} has-image{{/objectImage}}">
                    <div class="tool-image">
                        {{#objectImage}}
                            <img src="{{ objectImage }}" alt="{{ objectTitle }}" />
                        {{/objectImage}}
                        {{^objectImage}}
                            <i class="fa fa-image" aria-hidden="true"></i>
                        {{/objectImage}}
                    </div>
                    <div class="tool-info">
                        <h2 data-filter-id="{{ objectFilterIds[0] }}"></h2>
                        <h3>{{ objectTitle }}</h3>
                        <p>{{ objectMetaDescription }}</p>
                    </div>
                </a>
            `,
            empty: hpaTranslatedtext.algoliaSearch.calculatorHolderPage.noResults, // No tools were found for your search
            showMoreText: hpaTranslatedtext.algoliaSearch.calculatorHolderPage.showMore, // Show More
        };

        var templatePodcast = {
            item: `
                <div class="algolia-podcast" data-object-id="{{objectID}}" data-hit-index="{{__hitIndex}}" data-position="{{__position}}" data-query-id="{{__queryID}}">
                    <h4>{{#helpers.highlight}}{ "attribute": "objectTitle" }{{/helpers.highlight}}</h4>
                    <div class="content">{{#helpers.snippet}}{ "attribute": "objectContent" }{{/helpers.snippet}}</div>
                    <a class="read-more" href="{{ objectLink }}">Listen here <svg xmlns="http://www.w3.org/2000/svg" viewBox="233.6 134.4 492.8 291.2" class="svg-arrow-right"><path d="M578.9 134.4l-26.1 26.1 102.7 102.7H233.6v37.3h421.9l-99 99 26.2 26.1 143.7-143.7z"></path></svg></a>
                </div>
            `,
            empty: hpaTranslatedtext.algoliaSearch.podcastHolderPage.noResults, // No Podcasts were found for your search
            showMoreText: hpaTranslatedtext.algoliaSearch.podcastHolderPage.loadMore, // Load More
        };
    }

    if (page == 'ArchivedWebinarHolder' || page == 'QAndAVideoHolder') {
        // ArchivedWebinarHolder Page Start
        const archivedWebinarsListingWrapper = $('.archived-webinars-listing-wrapper');
        let objectClassName =  'hpa\\mysite\\ArchivedWebinar';

        if (page == 'QAndAVideoHolder') {
            objectClassName = 'hpa\\mysite\\QAndAVideoPage'; // This is the Silverstripe ClassName
            templatesArchivedWebinars.empty = hpaTranslatedtext.algoliaSearch.qAndAVideoHolder.noResults; // No videos were found for your search
        }

        $('.archived-webinars-filter').on('click', function() {
            var $this = $(this),
                id = parseInt($this.data('id')),
                alreadySelected = $this.hasClass('selected');
            if (isNaN(id)) id = 0;

            resetSearchResultsPage = true;

            // Remove objectFilterIDs from array
            var newAlgoliaFacetFilters = algoliaFacetFilters.filter(function(item) {
                return item.substr(0, 15) !== 'objectFilterIDs';
            });

            $('.archived-webinars-filter').removeClass('selected');
            if (!alreadySelected) {
                $this.addClass('selected');
                if (id > 0) {
                    // Add objectFilterIDs from array
                    newAlgoliaFacetFilters = newAlgoliaFacetFilters.concat(['objectFilterIDs:' + id]);
                }
            } else {
                $('.archived-webinars-filter[data-id="0"]').addClass('selected');
            }

            algoliaFacetFilters = newAlgoliaFacetFilters;

            mainInstantsearch.refresh();
        });

        mainInstantsearch = instantsearch({
            indexName: indexName,
            searchClient,
            searchFunction: function(helper) {
                var canSearch = false;

                if (hasUrlParameter('q') && !hasSearchedFromQuery) {
                    hasSearchedFromQuery = true;
                    helper.state.query = getUrlParameter('q');
                }

                var currentFacetFilters = helper.state.facetFilters;
                var newFacetFilters = currentFacetFilters.filter(function(item) {
                    return item.substr(0, 15) !== 'objectFilterIDs';
                });

                newFacetFilters = newFacetFilters.concat(algoliaFacetFilters);

                helper.state.facetFilters = newFacetFilters;

                helper.state.index = indexName;
                if (helper.state.query.length === 0) {
                    helper.state.index = indexNamePrefix + '_HPA_SortByTitleDesc';
                }

                if (resetSearchResultsPage) {
                    resetSearchResultsPage = false;
                    helper.state.page = 0;
                }

                canSearch = true;

                // console.log(helper);

                if (canSearch) {
                    algoliaSendQueryToGA(helper.state.query);
                    // console.log('Page:', helper.state.page);
                    helper.search(); // trigger search
                    $('.algolia-search-results-wrapper').show();
                }
            }
        });

        mainInstantsearch.addWidgets([
            instantsearchWidgets.configure({
                hitsPerPage: 6,
                facetFilters: [
                    'objectClassName:' + objectClassName,
                    'objectLocale:' + currentLocale,
                    // 'objectFilterIDs:1',
                ],
                clickAnalytics: true,
            }),
            instantsearchWidgets.searchBox({
                container: '#algolia-search-box',
                placeholder: searchBoxPlaceholder,
                searchAsYouType: true,
                showReset: true,
                showSubmit: false,
                showLoadingIndicator: false,
                queryHook: (query, search) => {
                    var canSearch = true;

                    if (canSearch) {
                        search(query);
                        $('.algolia-search-results-wrapper').show();
                    } else {
                        $('.algolia-search-results-wrapper').hide();
                    }
                }
            }),
            instantsearchWidgets.infiniteHits({
                container: '#algolia-archivedWebinars',
                templates: templatesArchivedWebinars,
                cssClasses: {
                    root: ['prev-webinars'],
                    list: ['prev-webinars-row'],
                    item: ['prev-webinar'],
                },
            })
        ]);

        mainInstantsearch.start();

        const infiniteHitsWrapper = $('.algolia-infiniteHits-wrapper');
        if (infiniteHitsWrapper.length) {
            $('.algolia-infiniteHits-wrapper').on('click', '.ais-InfiniteHits-loadMore', function() {
                const $loadMoreButton = $('.ais-InfiniteHits-loadMore');
                if ($loadMoreButton.length) {
                    if (!$loadMoreButton.hasClass('ais-InfiniteHits-loadMore--loading') && !$loadMoreButton.hasClass('ais-InfiniteHits-loadMore--disabled')) {
                        const orgiText = templatesArchivedWebinars.showMoreText; // This will be the translated "Show More"
                        $loadMoreButton.text(hpaTranslatedtext.algoliaSearch.general.loading /* Loading... */).addClass('ais-InfiniteHits-loadMore--loading');
                        setTimeout(function() {
                            $loadMoreButton.text(orgiText).removeClass('ais-InfiniteHits-loadMore--loading'); // Restore original translated text
                        }, 1500);
                    }
                }
            });

            const clickLoadMore = debounce(function() {
                $('.ais-InfiniteHits-loadMore').trigger('click');
            }, 100);

            // Now showing the load more button instead
            // $(window).on('scroll', function() {
            //     const scrollTopPosition = ($(document).scrollTop() - infiniteHitsWrapper.outerHeight() + 1500);
            //
            //     if (scrollTopPosition > 0) {
            //         clickLoadMore();
            //     }
            // });
        }

        const filterId = parseInt(getUrlParameter('fid'));
        if (filterId > 0) {
            const $fiterField = $('.archived-webinars-filter[data-id="' + filterId + '"]');
            if ($fiterField.length) {
                $fiterField.trigger('click');
            }
        }

        // ArchivedWebinarHolder Page End
    } else if (page === 'CalculatorHolderPage') {
        // CalculatorHolderPage Start
        let objectClassName =  'hpa\\mysite\\CalculatorPage'; // hpa\\mysite\\CalculatorPage

        // $('.archived-webinars-filter').on('click', function() {
        //     var $this = $(this),
        //         id = parseInt($this.data('id')),
        //         alreadySelected = $this.hasClass('selected');
        //     if (isNaN(id)) id = 0;
        //
        //     resetSearchResultsPage = true;
        //
        //     // Remove objectFilterIDs from array
        //     var newAlgoliaFacetFilters = algoliaFacetFilters.filter(function(item) {
        //         return item.substr(0, 15) !== 'objectFilterIDs';
        //     });
        //
        //     $('.archived-webinars-filter').removeClass('selected');
        //     if (!alreadySelected) {
        //         $this.addClass('selected');
        //         if (id > 0) {
        //             // Add objectFilterIDs from array
        //             newAlgoliaFacetFilters = newAlgoliaFacetFilters.concat(['objectFilterIDs:' + id]);
        //         }
        //     } else {
        //         $('.archived-webinars-filter[data-id="0"]').addClass('selected');
        //     }
        //
        //     algoliaFacetFilters = newAlgoliaFacetFilters;
        //
        //     mainInstantsearch.refresh();
        // });

        mainInstantsearch = instantsearch({
            indexName: indexName,
            searchClient,
            searchFunction: function(helper) {
                var canSearch = false;

                if (hasUrlParameter('q') && !hasSearchedFromQuery) {
                    hasSearchedFromQuery = true;
                    helper.state.query = getUrlParameter('q');
                }

                var currentFacetFilters = helper.state.facetFilters;
                var newFacetFilters = currentFacetFilters.filter(function(item) {
                    return item.substr(0, 15) !== 'objectFilterIDs';
                });

                newFacetFilters = newFacetFilters.concat(algoliaFacetFilters);

                helper.state.facetFilters = newFacetFilters;

                helper.state.index = indexName;
                if (helper.state.query.length === 0) {
                    helper.state.index = indexNamePrefix + '_HPA_SortByTitleDesc';
                }

                if (resetSearchResultsPage) {
                    resetSearchResultsPage = false;
                    helper.state.page = 0;
                }

                canSearch = true;

                // console.log(helper);

                if (canSearch) {
                    algoliaSendQueryToGA(helper.state.query);
                    // console.log('Page:', helper.state.page);
                    helper.search(); // trigger search
                }
            }
        });

        mainInstantsearch.addWidgets([
            instantsearchWidgets.configure({
                hitsPerPage: 6,
                facetFilters: [
                    'objectClassName:' + objectClassName,
                    'objectLocale:' + currentLocale,
                    // 'objectFilterIDs:1',
                ],
                clickAnalytics: true,
            }),
            instantsearchWidgets.searchBox({
                container: '#algolia-search-box',
                placeholder: searchBoxPlaceholder,
                searchAsYouType: true,
                showReset: true,
                showSubmit: false,
                showLoadingIndicator: false,
                queryHook: (query, search) => {
                    var canSearch = true;

                    if (canSearch) {
                        search(query);
                    }
                }
            }),
            instantsearchWidgets.infiniteHits({
                container: '#algolia-calculatorPages',
                templates: templatesCalculatorPages,
                cssClasses: {
                    root: ['tools-grid-wrapper'],
                    list: ['tools-grid'],
                    item: ['tool-card'],
                },
            })
        ]);

        mainInstantsearch.start();

        const $infiniteHitsWrapper = $('#algolia-calculatorPages');
        if ($infiniteHitsWrapper.length) {
            $infiniteHitsWrapper.on('click', '.ais-InfiniteHits-loadMore', function() {
                const $loadMoreButton = $('.ais-InfiniteHits-loadMore');
                if ($loadMoreButton.length) {
                    if (!$loadMoreButton.hasClass('ais-InfiniteHits-loadMore--loading') && !$loadMoreButton.hasClass('ais-InfiniteHits-loadMore--disabled')) {
                        const orgiText = templatesCalculatorPages.showMoreText; // This will be the translated "Show More"
                        $loadMoreButton.text(hpaTranslatedtext.algoliaSearch.general.loading).addClass('ais-InfiniteHits-loadMore--loading');
                        setTimeout(function() {
                            $loadMoreButton.text(orgiText).removeClass('ais-InfiniteHits-loadMore--loading'); // Restore original translated text
                        }, 1500);
                    }
                }
            });

            const clickLoadMore = debounce(function() {
                $('.ais-InfiniteHits-loadMore').trigger('click');
            }, 100);

            // Now showing the load more button instead
            // $(window).on('scroll', function() {
            //     const scrollTopPosition = ($(document).scrollTop() - infiniteHitsWrapper.outerHeight() + 1500);
            //
            //     if (scrollTopPosition > 0) {
            //         clickLoadMore();
            //     }
            // });
        }

        // CalculatorHolderPage End
    } else if (page === 'PodcastHolderPage') {
        // PodcastHolderPage Start
        const archivedWebinarsListingWrapper = $('.archived-webinars-listing-wrapper');
        let objectClassName =  'SilverStripe\\Blog\\Model\\BlogPost';

        mainInstantsearch = instantsearch({
            indexName: indexName,
            searchClient,
            searchFunction: function(helper) {
                var canSearch = false;

                if (hasUrlParameter('q') && !hasSearchedFromQuery) {
                    hasSearchedFromQuery = true;
                    helper.state.query = getUrlParameter('q');
                }

                canSearch = true;

                // console.log(helper);

                if (canSearch) {
                    algoliaSendQueryToGA(helper.state.query);
                    // console.log('Page:', helper.state.page);
                    helper.search(); // trigger search
                    $('.algolia-search-results-wrapper').show();
                }
            }
        });

        mainInstantsearch.addWidgets([
            instantsearchWidgets.configure({
                hitsPerPage: 6,
                facetFilters: [
                    'objectGroupID:Podcast',
                    'objectLocale:' + currentLocale,
                    // 'objectClassName:' + objectClassName,
                    // 'objectFilterIDs:1',
                ],
                clickAnalytics: true,
            }),
            instantsearchWidgets.searchBox({
                container: '#algolia-search-box',
                placeholder: searchBoxPlaceholder,
                searchAsYouType: true,
                showReset: true,
                showSubmit: false,
                showLoadingIndicator: false,
                queryHook: (query, search) => {
                    var canSearch = true;

                    if (canSearch) {
                        search(query);
                        $('.algolia-search-results-wrapper').show();
                    } else {
                        $('.algolia-search-results-wrapper').hide();
                    }
                }
            }),
            instantsearchWidgets.infiniteHits({
                container: '#algolia-archivedWebinars',
                templates: templatePodcast,
                cssClasses: {
                    root: ['podcasts'],
                    list: ['podcasts-row'],
                    item: ['podcast-item'],
                },
            })
        ]);

        mainInstantsearch.start();

        const infiniteHitsWrapper = $('.algolia-infiniteHits-wrapper');
        if (infiniteHitsWrapper.length) {
            $('.algolia-infiniteHits-wrapper').on('click', '.ais-InfiniteHits-loadMore', function() {
                const $loadMoreButton = $('.ais-InfiniteHits-loadMore');
                if ($loadMoreButton.length) {
                    if (!$loadMoreButton.hasClass('ais-InfiniteHits-loadMore--loading') && !$loadMoreButton.hasClass('ais-InfiniteHits-loadMore--disabled')) {
                        const orgiText = templatePodcast.showMoreText; // This will be the translated "Load More"
                        $loadMoreButton.text(hpaTranslatedtext.algoliaSearch.general.loading /* Loading... */).addClass('ais-InfiniteHits-loadMore--loading');
                        setTimeout(function() {
                            $loadMoreButton.text(orgiText).removeClass('ais-InfiniteHits-loadMore--loading'); // Restore original translated text
                        }, 1500);
                    }
                }
            });

            const clickLoadMore = debounce(function() {
                $('.ais-InfiniteHits-loadMore').trigger('click');
            }, 100);

            // Now showing the load more button instead
            // $(window).on('scroll', function() {
            //     const scrollTopPosition = ($(document).scrollTop() - infiniteHitsWrapper.outerHeight() + 1500);
            //
            //     if (scrollTopPosition > 0) {
            //         clickLoadMore();
            //     }
            // });
        }

        // PodcastHolderPage End

    } else if ($('#algolia-search-box').length) {

        mainInstantsearch = instantsearch({
            indexName: indexName,
            searchClient,
            searchFunction: function(helper) {
                var canSearch = false;

                if (hasUrlParameter('q') && !hasSearchedFromQuery) {
                    hasSearchedFromQuery = true;
                    helper.state.query = getUrlParameter('q');
                }

                if (helper.state.query.length > 0) {
                    canSearch = true;
                }

                if (canSearch) {
                    algoliaSendQueryToGA(helper.state.query);
                    helper.search(); // trigger search
                    $('.algolia-search-results-wrapper').show();
                }
            }
        });

        const widgetsArray = [];
        widgetsArray.push(
            instantsearchWidgets.searchBox({
                container: '#algolia-search-box',
                placeholder: searchBoxPlaceholder, // Placeholder is already translated based on page type
                searchAsYouType: true,
                showReset: true,
                showSubmit: false,
                showLoadingIndicator: true,
                queryHook: (query, search) => {
                    var canSearch = false;
                    if (query !== "") {
                        canSearch = true;
                    }

                    if (canSearch) {
                        search(query);
                        $('.algolia-search-results-wrapper').show();
                    } else {
                        $('.algolia-search-results-wrapper').hide();
                    }
                }
            })
        );

        if ($('#algolia-courses').length) {
            widgetsArray.push(
                instantsearchWidgets
                .index({
                    indexName: indexName,
                })
                .addWidgets([
                    instantsearchWidgets.configure({
                        // hitsPerPage: 4,
                        clickAnalytics: true,
                        facetFilters: [
                            'objectClassName:hpa\\mysite\\CourseEntry',
                            'objectLocale:' + currentLocale,
                        ],
                    }),
                    instantsearchWidgets.hits({
                        container: '#algolia-courses',
                        templates: template,
                    }),
                    instantsearchWidgets.pagination({
                        container: '#algolia-courses-pagination',
                        cssClasses: {
                            list: 'pagination',
                            selectedItem: 'active',
                        },
                        scrollTo: false
                    }),
                ])
            );
        }

        if ($('#algolia-techArticles').length) {
            widgetsArray.push(
                instantsearchWidgets
                .index({
                    indexName: indexName,
                })
                .addWidgets([
                    instantsearchWidgets.configure({
                        // hitsPerPage: 4,
                        clickAnalytics: true,
                        facetFilters: [
                            'objectClassName:hpa\\mysite\\TechArticle',
                            'objectLocale:' + currentLocale,
                        ]
                    }),
                    instantsearchWidgets.hits({
                        container: '#algolia-techArticles',
                        templates: template,
                    }),
                    instantsearchWidgets.pagination({
                        container: '#algolia-techArticles-pagination',
                        cssClasses: {
                            list: 'pagination',
                            selectedItem: 'active',
                        },
                        scrollTo: false
                    }),
                ])
            );
        }

        if ($('#algolia-blogPosts').length) {
            widgetsArray.push(
                instantsearchWidgets
                .index({
                    indexName: indexName,
                })
                .addWidgets([
                    instantsearchWidgets.configure({
                        // hitsPerPage: 4,
                        clickAnalytics: true,
                        facetFilters: [
                            'objectClassName:SilverStripe\\Blog\\Model\\BlogPost',
                            'objectLocale:' + currentLocale,
                        ]
                    }),
                    instantsearchWidgets.hits({
                        container: '#algolia-blogPosts',
                        templates: template,
                    }),
                    instantsearchWidgets.pagination({
                        container: '#algolia-blogPosts-pagination',
                        cssClasses: {
                            list: 'pagination',
                            selectedItem: 'active',
                        },
                        scrollTo: false
                    }),
                ])
            );
        }

        if ($('#algolia-forumPosts').length) {
            widgetsArray.push(
                instantsearchWidgets
                .index({
                    indexName: indexName,
                })
                .addWidgets([
                    instantsearchWidgets.configure({
                        clickAnalytics: true,
                        facetFilters: [
                            'objectClassName:hpa\\forum\\Post'
                        ],
                    }),
                    instantsearchWidgets.hits({
                        container: '#algolia-forumPosts',
                        templates: template,
                    }),
                    instantsearchWidgets.pagination({
                        container: '#algolia-forumPosts-pagination',
                        cssClasses: {
                            list: 'pagination',
                            selectedItem: 'active',
                        },
                        scrollTo: false
                    }),
                ])
            );
        }

        if ($('#algolia-archivedWebinars').length) {
            widgetsArray.push(
                instantsearchWidgets
                .index({
                    indexName: indexName,
                }).addWidgets([
                    instantsearchWidgets.configure({
                        hitsPerPage: 6,
                        clickAnalytics: true,
                        facetFilters: [
                            'objectClassName:hpa\\mysite\\ArchivedWebinar',
                            'objectLocale:' + currentLocale,
                        ],
                    }),
                    instantsearchWidgets.hits({
                        container: '#algolia-archivedWebinars',
                        templates: template,
                        // cssClasses: {
                        //     root: ['prev-webinars'],
                        //     list: ['prev-webinars-row'],
                        //     item: ['prev-webinar'],
                        // },
                    }),
                    instantsearchWidgets.pagination({
                        container: '#algolia-archivedWebinars-pagination',
                        cssClasses: {
                            list: 'pagination',
                            selectedItem: 'active',
                        },
                        scrollTo: false
                    }),
                ])
            );
        }

        if ($('#algolia-qAndAVideoPages').length) {
            widgetsArray.push(
                instantsearchWidgets
                .index({
                    indexName: indexName,
                }).addWidgets([
                    instantsearchWidgets.configure({
                        hitsPerPage: 6,
                        clickAnalytics: true,
                        facetFilters: [
                            'objectClassName:hpa\\mysite\\QAndAVideoPage',
                            'objectLocale:' + currentLocale,
                        ],
                    }),
                    instantsearchWidgets.hits({
                        container: '#algolia-qAndAVideoPages',
                        templates: template,
                        // cssClasses: {
                        //     root: ['prev-webinars'],
                        //     list: ['prev-webinars-row'],
                        //     item: ['prev-webinar'],
                        // },
                    }),
                    instantsearchWidgets.pagination({
                        container: '#algolia-qAndAVideoPages-pagination',
                        cssClasses: {
                            list: 'pagination',
                            selectedItem: 'active',
                        },
                        scrollTo: false
                    }),
                ])
            );
        }

        mainInstantsearch.addWidgets(widgetsArray);
        mainInstantsearch.start();
    }

    var algoliaHeaderSearch = $('#algolia-header-search2'),
        algoliaHeaderSearchBox = $('#algolia-header-search-box'),
        algoliaHeaderSearchResultsWrapper = algoliaHeaderSearch.find('.algolia-dropdown-search-results-wrapper'),
        headerSearchTemplate = {
            item: `
              <a href="{{ objectLink }}" class="algolia-object" data-object-id="{{objectID}}" data-hit-index="{{__hitIndex}}" data-position="{{__position}}" data-query-id="{{__queryID}}">
                <div class="title">
                    <span class="object-title">{{#helpers.highlight}}{ "attribute": "objectTitle" }{{/helpers.highlight}}</span>
                    <span class="label label-default" data-type="{{ objectGroupID }}"></span>
                </div>
                <div class="description">{{#helpers.snippet}}{ "attribute": "objectContent" }{{/helpers.snippet}}</div>
              </a>
            `,
        };
    if (algoliaHeaderSearchBox.length) {
        const headerInstantSearch = instantsearch({
            indexName: indexName,
            searchClient,
            searchFunction: function(helper) {
                if (helper.state.query.length === 0) {
                    return; // do not trigger search
                }

                algoliaSendQueryToGA(helper.state.query);
                helper.search(); // trigger search
            }
        });

        headerInstantSearch.addWidgets([
            instantsearchWidgets.searchBox({
                container: '#algolia-header-search-box',
                placeholder: hpaTranslatedtext.algoliaSearch.header.searchBoxPlaceholder, // Search Courses, Articles, Forum...
                searchAsYouType: true,
                showReset: false,
                showSubmit: false,
                showLoadingIndicator: false,
                queryHook: (query, search) => {
                    if (query !== '') {
                        search(query);
                        algoliaHeaderSearchResultsWrapper.show();
                    } else {
                        algoliaHeaderSearchResultsWrapper.hide();
                    }
                }
            }),
            instantsearchWidgets.configure({
                clickAnalytics: true,
                ranking: relevanceFirstRanking,
                // https://www.algolia.com/doc/api-reference/api-parameters/facetFilters/
                facetFilters: [
                    'objectLocale:' + currentLocale,
                    [
                        'objectClassName:hpa\\mysite\\CourseEntry',
                        // 'objectClassName:hpa\\mysite\\CourseComponent',
                        'objectClassName:hpa\\mysite\\DealsPage',
                        'objectClassName:hpa\\mysite\\StarterPage',
                        'objectClassName:hpa\\mysite\\VIPSignupPage',
                        // 'objectClassName:hpa\\mysite\\ArchivedWebinar',
                        // 'objectClassName:hpa\\mysite\\TechArticle',
                        // 'objectClassName:SilverStripe\\Blog\\Model\\BlogPost',
                        'objectClassName:-hpa\\forum\\Post',
                    ]
                ],
                // Priorities courses over other pagetypes
                // Optional Filters are used to prioritize results
                // https://www.algolia.com/doc/api-reference/api-parameters/optionalFilters/#examples
                optionalFilters: [
                    'objectClassName:hpa\\mysite\\CourseEntry', // Give courses highest priority
                    // 'objectClassName:hpa\\mysite\\CourseComponent',
                    // 'objectClassName:hpa\\mysite\\ArchivedWebinar',
                    // 'objectClassName:hpa\\mysite\\TechArticle',
                    // 'objectClassName:SilverStripe\\Blog\\Model\\BlogPost',
                    'objectClassName:-hpa\\forum\\Post' // Give forum posts lowest proprity
                ]
            }),
            instantsearchWidgets.hits({
                container: '#algolia-header-search-results',
                templates: headerSearchTemplate,
            }),
        ]);

        headerInstantSearch.start();

        var $headerSearchWrapper = $('#algolia-header-search2'),
            $contactUsPopupFormWrapper = $('#contact-us-popup-form-wrapper');
        $('#header-search-icon2').on('click', function() {
            const $this = $(this),
                $headerSearchInputField = $headerSearchWrapper.find('.ais-SearchBox-input'),
                $headerSearchResultsWrapper = $headerSearchWrapper.find('.algolia-dropdown-search-results-wrapper'),
                $headerSearchResultsViewMore = $headerSearchResultsWrapper.find('.algolia-dropdown-search-results-view-more'),
                $headerMenu = $('.header__top__nav__items'),
                $subNavContainer = $('.js-hamburger');

            if ($subNavContainer.hasClass('nav-open')) { // menu is open
                $subNavContainer.find('.nav-trigger').trigger('click'); // close the menu
            }

            $headerSearchWrapper.toggle();

            if ($headerSearchWrapper.is(':visible')) {
                $headerSearchInputField.focus();
                $contactUsPopupFormWrapper.hide();
            } else {

            }

            toggleHeaderSearchBackground();
        });

        $('.js-algolia-header-search-box-close').on('click', function() {
            $headerSearchWrapper.toggle();
            toggleHeaderSearchBackground();
        });

        $('#header-search-icon').on('click', function() {
            const $this = $(this);

            if ($this.hasClass('glyphicon-search')) {
                $('.header__top__nav__items_first').hide();
                if ($(window).width() <= 992) {
                    $('.main-header__top__nav').hide();
                }
                $('#algolia-header-search-box').show();
                $('#algolia-header-search-box .ais-SearchBox-input').focus();
                if ($('#algolia-header-search-box .ais-SearchBox-input').val() !== '') {
                    $('#algolia-header-search-results, #algolia-header-search .algolia-dropdown-search-results-view-more').show();
                }
                $this.removeClass('glyphicon-search').addClass('glyphicon-remove');
                $this.parent().addClass('open');
                $this.parent().parent().addClass('search-open'); // .header__main__top
            } else {
                $('.header__top__nav__items_first').show();
                $('.main-header__top__nav').show();
                $('#algolia-header-search-box').hide();
                $('#algolia-header-search-results, #algolia-header-search .algolia-dropdown-search-results-view-more').hide();
                $this.removeClass('glyphicon-remove').addClass('glyphicon-search');
                $this.parent().removeClass('open');
                $this.parent().parent().removeClass('search-open');
            }
        });

        algoliaHeaderSearchBox.find('.ais-SearchBox-input').keypress(function (e) {
            var $this = $(this),
                key = e.which;

            if (key == 13) { // the enter key code
                window.location.href = searchResultsUrlPath + '?q=' + encodeURIComponent($this.val());
            }
        });

        algoliaHeaderSearch.find('.algolia-dropdown-search-results-view-more a').on('click', function(e) {
            e.preventDefault();

            const queryString = algoliaHeaderSearchBox.find('.ais-SearchBox-input').val();
            if (queryString) {
                window.location.href = searchResultsUrlPath + '?q=' + encodeURIComponent(queryString);
            }
        });
    }

    var algoliaDropdownSearch = $('#algolia-dropdown-search'),
        algoliaDropdownSearchBox = $('#algolia-dropdown-search-box'),
        algoliaDropdownSearchResultsWrapper = algoliaDropdownSearch.find('.algolia-dropdown-search-results-wrapper');;
    if (algoliaDropdownSearchBox.length) {


        const headerInstantSearch = instantsearch({
            indexName: indexName,
            searchClient,
            searchFunction: function(helper) {
                if (helper.state.query.length === 0) {
                    return; // do not trigger search
                }

                algoliaSendQueryToGA(helper.state.query);
                helper.search(); // trigger search
            }
        });

        headerInstantSearch.addWidgets([
            instantsearchWidgets.searchBox({
                container: '#algolia-dropdown-search-box',
                placeholder: hpaTranslatedtext.algoliaSearch.header.searchBoxPlaceholder, // Search Courses, Articles, Forum...
                searchAsYouType: true,
                showReset: true,
                showSubmit: false,
                showLoadingIndicator: false,
                queryHook: (query, search) => {
                    if (query !== "") {
                        search(query);
                        algoliaDropdownSearchResultsWrapper.show();
                    } else {
                        algoliaDropdownSearchResultsWrapper.hide();
                    }
                }
            }),
            instantsearchWidgets.configure({
                clickAnalytics: true,
                ranking: relevanceFirstRanking,
                // https://www.algolia.com/doc/api-reference/api-parameters/facetFilters/
                facetFilters: [
                    'objectLocale:' + currentLocale,
                    [
                        'objectClassName:hpa\\mysite\\CourseEntry',
                        // 'objectClassName:hpa\\mysite\\CourseComponent',
                        'objectClassName:hpa\\mysite\\DealsPage',
                        'objectClassName:hpa\\mysite\\StarterPage',
                        'objectClassName:hpa\\mysite\\VIPSignupPage',
                        // 'objectClassName:hpa\\mysite\\ArchivedWebinar',
                        // 'objectClassName:hpa\\mysite\\TechArticle',
                        // 'objectClassName:SilverStripe\\Blog\\Model\\BlogPost',
                        'objectClassName:-hpa\\forum\\Post',
                    ]
                ],
                // Priorities courses over other pagetypes
                // Optional Filters are used to prioritize results
                // https://www.algolia.com/doc/api-reference/api-parameters/optionalFilters/#examples
                optionalFilters: [
                    'objectClassName:hpa\\mysite\\CourseEntry', // Give courses highest priority
                    // 'objectClassName:hpa\\mysite\\CourseComponent',
                    // 'objectClassName:hpa\\mysite\\ArchivedWebinar',
                    // 'objectClassName:hpa\\mysite\\TechArticle',
                    // 'objectClassName:SilverStripe\\Blog\\Model\\BlogPost',
                    'objectClassName:-hpa\\forum\\Post' // Give forum posts lowest proprity
                ]
            }),
            instantsearchWidgets.hits({
                container: '#algolia-dropdown-search-results',
                templates: headerSearchTemplate,
            }),
        ]);

        headerInstantSearch.start();

        algoliaDropdownSearchBox.find('.ais-SearchBox-input').keypress(function (e) {
            var $this = $(this),
                key = e.which;

            if (key == 13) { // the enter key code
                window.location.href = searchResultsUrlPath + '?q=' + encodeURIComponent($this.val());
            }
        });

        algoliaDropdownSearch.find('.algolia-dropdown-search-results-view-more a').on('click', function(e) {
            e.preventDefault();

            const queryString = algoliaDropdownSearchBox.find('.ais-SearchBox-input').val();
            if (queryString) {
                window.location.href = searchResultsUrlPath + '?q=' + encodeURIComponent(queryString);
            }
        });
    }

    if ($('.algolia-search-results-page').length) {
        var queryCurrent = '';

        $('.algolia-sortby-select').on('change', function() {
            searchResultsInstantSearch.refresh();
        });

        var templates = {
            item: function(item) {
                // console.log(item);

                const objectExtraData = (item.objectExtraData && Object.keys(item.objectExtraData).length ? item.objectExtraData : false),
                    isCourseOrPackage = (item.objectGroupID === 'Course' || item.objectGroupID === 'Package' ? true : false),
                    isForumPost = (item.objectGroupID === 'Forum_Post' ? true : false),
                    isCourseComponent = (item.objectGroupID === 'Course_Module' ? true : false);
                let courseIsOwned = false;

                if (item.objectClassName === 'hpa\\mysite\\CourseEntry') {
                    if (gtmMemberData !== false) {
                        gtmMemberCourses.forEach(function(course, index, array) {
                            if (course.course_id == item.objectSilverstripeID) {
                                courseIsOwned = true;
                            }
                        });
                    }
                }

                let queryCountRegex = new RegExp(queryCurrent, 'gim'),
                    queryTitleCount = (item.objectTitle.match(queryCountRegex) || []).length,
                    queryContentCount = (item.objectContent.match(queryCountRegex) || []).length,
                    queryContentExtraCount = ('objectContentExtra' in item ? (item.objectContentExtra.match(queryCountRegex) || []).length : 0),
                    queryTotalCount = queryTitleCount + queryContentCount + queryContentExtraCount;

                let link = item.objectLink;
                if (item.objectClassName === 'hpa\\mysite\\CourseEntry') {
                    if (courseIsOwned) {
                        // Don't do this because it doesn't work with multiple languages
                        // They will get redirect to thew dashboard if they own it
                        // link = '/dashboard' + link;
                    }
                }

                let html = `<div class="row algolia-object" data-object-id="${item.objectID}" data-hit-index="${item.__hitIndex}" data-position="${item.__position}" data-query-id="${item.__queryID}">`;
                if (!isForumPost) {
                    html += `<div class="col-xs-12 col-sm-3 image">
                            <a href="${link}" target="_blank"><img src="${item.objectImage}" alt="" /></a>
                        </div>`;
                }
                html += `<div class="col-xs-12 ${isCourseOrPackage || isCourseComponent ? 'col-sm-6' : (isForumPost ? '' : 'col-sm-9')} content">
                        <span class="label label-primary" data-type="${item.objectGroupID}"></span>
                        <a href="${link}" target="_blank">${item.objectTitle}</a>`;
                if (!isCourseOrPackage && item._snippetResult.objectContent.value) html += `<p>${item._snippetResult.objectContent.value}</p>`;

                html += `<ul class="points">`;
                if (objectExtraData) {
                    if (item.objectClassName === 'hpa\\mysite\\CourseEntry') {

                        if ('ModulesCount' in objectExtraData) {
                            if (objectExtraData.ModulesCount) {
                                html += `<li>${objectExtraData.ModulesCount}</li>`;
                            }
                        }
                        if ('CompetencyLevel' in objectExtraData) {
                            if (objectExtraData.CompetencyLevel) {
                                html += `<li>${objectExtraData.CompetencyLevel}</li>`;
                            }
                        }
                        if ('StudentsEnrolledCount' in objectExtraData) {
                            if (objectExtraData.StudentsEnrolledCount) {
                                html += `<li>${objectExtraData.StudentsEnrolledCount}</li>`;
                            }
                        }

                    } else if (item.objectClassName === 'hpa\\mysite\\ArchivedWebinar' || item.objectClassName === 'hpa\\mysite\\QAndAVideoPage') {

                        if ('VideoDuration' in objectExtraData) {
                            if (objectExtraData.VideoDuration) {
                                html += `<li>${objectExtraData.VideoDuration}</li>`;
                            }
                        }

                    } else if (item.objectClassName === 'SilverStripe\\Blog\\Model\\BlogPost' || item.objectClassName === 'hpa\\mysite\\TechArticle') {

                        if ('EstimatedReadingTime' in objectExtraData) {
                            if (objectExtraData.EstimatedReadingTime) {
                                html += `<li>${objectExtraData.EstimatedReadingTime}</li>`;
                            }
                        }

                    } else if (isCourseComponent) {

                        if ('CourseTitle' in objectExtraData) {
                            if (objectExtraData.CourseTitle) {
                                html += `<li>${objectExtraData.CourseTitle}</li>`;
                            }
                        }

                        if ('StudentsEnrolledCount' in objectExtraData) {
                            if (objectExtraData.StudentsEnrolledCount) {
                                html += `<li>${objectExtraData.StudentsEnrolledCount}</li>`;
                            }
                        }

                    }
                }

                if (queryTotalCount) {
                    let mentionedText;
                    if (queryTotalCount === 1) {
                        // Assuming queryMentionedSingle is like: '"%s" mentioned 1 time'
                        mentionedText = hpaTranslatedtext.algoliaSearch.resultsPage.queryMentionedSingle
                                            .replace('%s', `"${queryCurrent}"`)
                    } else {
                        // Assuming queryMentionedMultiple is like: '"%s" mentioned %d times'
                        mentionedText = hpaTranslatedtext.algoliaSearch.resultsPage.queryMentionedMultiple
                                            .replace('%s', `"${queryCurrent}"`)
                                            .replace('%d', queryTotalCount);
                    }
                    html += `<li class="query-count"><span>${mentionedText}</span></li>`;
                }

                html += `</ul>`;

                html += `</div>`;

                if (isCourseOrPackage || isCourseComponent) {
                    html += `<div class="col-xs-12 col-sm-3 button">`;
                    if (objectExtraData && isCourseOrPackage) {
                        if ('UnitPrice' in objectExtraData) {

                            let showPrice = true,
                                price = parseFloat(objectExtraData.UnitPrice),
                                salePrice = false;
                            if (isNaN(price)) price = 0;

                            // price increase and dicounts are in courseData
                            const course = courseData.find(course => course.ID == item.objectSilverstripeID);
                            if (course) {
                                price = parseFloat(course.UnitPrice);
                                if (price > 0) {
                                    price = price.toFixed(2);
                                    if ((price%1) === 0) { // if it's a whole number it will return 0
                                        price = parseInt(price);
                                    }

                                    salePrice = (course.ItemPrice != course.UnitPrice ? parseFloat(course.ItemPrice) : false);
                                    if (salePrice) {
                                        salePrice = salePrice.toFixed(2);
                                        if ((salePrice%1) === 0) { // if it's a whole number it will return 0
                                            salePrice = parseInt(salePrice);
                                        }
                                    }
                                }
                            }

                            if (!courseIsOwned) {
                                html += `<div class="price">`;
                                if (salePrice) {
                                    html += `<span class="price-current">\$${salePrice}</span><span class="price-old">\$${price}</span>`;
                                } else {
                                    html += `<span class="price-current">`;
                                    if (price === 0) {
                                        html += `Free`;
                                    } else {
                                        html += `\$${price}`;
                                    }
                                    html += `</span>`;
                                }
                                html += `</div>`;
                            }
                        }
                    }
                    html += `<a href="${link}" target="_blank" class="btn btn-primary" data-type="${item.objectGroupID}${item.objectClassName === 'hpa\\mysite\\CourseEntry' && courseIsOwned ? '-owned' : ''}"></a></div>`;
                    html += `</div>`;
                }

                return html;
            },
            empty: hpaTranslatedtext.algoliaSearch.resultsPage.noResultsForQuery, // No results for <q>{{ query }}</q>
            showMoreText: hpaTranslatedtext.algoliaSearch.resultsPage.loadMoreResults, // Load More Results
        };

        // This doesn't work when using refinementList becuase these are always sent along even when filtering
        // const facetFilters = [
        //     [
        //         'objectClassName:hpa\\mysite\\CourseEntry',
        //         'objectClassName:hpa\\mysite\\ArchivedWebinar',
        //         'objectClassName:hpa\\mysite\\TechArticle',
        //     ]
        // ];

        // https://www.algolia.com/doc/guides/managing-results/refine-results/filtering/in-depth/filters-and-facetfilters/#syntax-difference-between-filters-and-facetfilters
        // Additionally, Algolia allows you to negate facet filters using a minus sign (-), sometimes called a dash. In this example, ebooks would be excluded from the results.
        // If you want to exclude any facits use this
        // This does work when using refinementList to
        // const facetFilters = [
        //     'objectClassName:-hpa\\mysite\\VIPSignupPage',
        //     'objectClassName:-hpa\\mysite\\DealsPage',
        //     'objectClassName:-hpa\\forum\\Forum',
        //     'objectClassName:-Page',
        // ];

        // const labels = [
        //     {
        //         title: 'Webinars',
        //         className: 'hpa\\mysite\\ArchivedWebinar'
        //     },
        //     {
        //         title: 'Tech Articles',
        //         className: 'hpa\\mysite\\TechArticle'
        //     },
        //     {
        //         title: 'Q&A Videos',
        //         className: 'hpa\\mysite\\QAndAVideoPage'
        //     },
        //     {
        //         title: 'Courses',
        //         className: 'hpa\\mysite\\CourseEntry'
        //     },
        //     {
        //         title: 'Blog Posts',
        //         className: 'SilverStripe\\Blog\\Model\\BlogPost'
        //     },
        //     {
        //         title: 'Forum Posts',
        //         className: 'hpa\\forum\\Post'
        //     },
        // ];

        var searchResultsInstantSearch = instantsearch({
            indexName: indexName,
            searchClient,
            searchFunction: function(helper) {

                // Need to add it here rather than in the instantsearchWidgets.configure() facetFilters array
                // because when the
                // if (!helper.state.disjunctiveFacets.includes('objectLocale')) {
                //     helper.state.disjunctiveFacets.push('objectLocale');
                //     helper.state.disjunctiveFacetsRefinements.objectLocale = [currentLocale];
                // }

                // console.log('searchFunction');
                // Algolia Helper info - https://community.algolia.com/algoliasearch-helper-js/reference.html
                // console.log(helper.state);
                var canSearch = false;

                if (hasUrlParameter('q') && !hasSearchedFromQuery) {
                    hasSearchedFromQuery = true;
                    helper.state.query = getUrlParameter('q');
                }

                if (helper.state.query && helper.state.query.length > 0) {
                    canSearch = true;
                }

                // by default ranking is not used
                // if ('ranking' in helper.state) {
                //     delete helper.state.ranking;
                // }
                helper.state.ranking = relevanceFirstRanking;
                const sortByDropdown = $('.algolia-sortby-select');
                if (sortByDropdown.length) {
                    if (sortByDropdown.val() == 'recentlyAdded') {
                        helper.state.ranking = ['custom']; // This makes it use "(CUSTOM RANKING) objectCreated" on the primary index.
                    }
                }
                // console.log(sortByDropdown.val());
                // console.log(helper.state);

                // console.log('canSearch', canSearch);
                // console.log('hasSearchedFromQuery', hasSearchedFromQuery);
                // console.log('helper.state.query', helper.state.query);

                if (canSearch) {
                    queryCurrent = helper.state.query;
                    // console.log('searchFunction searching');
                    // algoliaSendQueryToGA(helper.state.query);
                    helper.search(); // trigger search
                    $('.algolia-search-results-full-wrapper').show();
                }
                // console.log('');
            }
        });

        searchResultsInstantSearch.addWidgets([
            instantsearchWidgets.searchBox({
                container: '#algolia-search-results-search-box',
                placeholder: hpaTranslatedtext.algoliaSearch.resultsPage.searchBoxPlaceholder, // Search Courses, Webinars, Articles, Forum...
                searchAsYouType: true,
                showReset: true,
                showSubmit: false,
                showLoadingIndicator: false,
                queryHook: (query, search) => {
                    // console.log('queryHook');
                    var canSearch = false;
                    if (query !== "") {
                        canSearch = true;
                    }
                    // console.log('canSearch', canSearch);
                    if (canSearch) {
                        queryCurrent = query;
                        // console.log('queryHook searching');
                        search(query);
                        $('.algolia-search-results-full-wrapper').show();
                    } else {
                        $('.algolia-search-results-full-wrapper').hide();
                    }
                    // console.log('');
                }
            }),
            instantsearchWidgets.configure({
                hitsPerPage: 8,
                clickAnalytics: true,
                // https://www.algolia.com/doc/api-reference/api-parameters/facetFilters/
                facetFilters: [
                    // 'objectLocale:' + currentLocale, // added to disjunctiveFacets in searchFunction
                ],
                filters: 'objectLocale:' + currentLocale + ' OR objectGroupID:Forum_Post',

                // Prioritizes courses over other pagetypes
                // Optional Filters are used to prioritize results
                // https://www.algolia.com/doc/api-reference/api-parameters/optionalFilters/#examples
                optionalFilters: [
                    'objectClassName:hpa\\mysite\\CourseEntry', // Give courses highest priority
                    'objectClassName:hpa\\mysite\\CourseComponent',
                    'objectClassName:hpa\\mysite\\DealsPage',
                    'objectClassName:hpa\\mysite\\StarterPage',
                    'objectClassName:hpa\\mysite\\VIPSignupPage',
                    // 'objectClassName:hpa\\mysite\\ArchivedWebinar',
                    // 'objectClassName:hpa\\mysite\\TechArticle',
                    // 'objectClassName:SilverStripe\\Blog\\Model\\BlogPost',
                    'objectClassName:-hpa\\forum\\Post' // Give forum posts lowest proprity
                ]
            }),
            instantsearchWidgets.infiniteHits({
                container: '#algolia-search-results',
                templates: templates,
                // https://www.algolia.com/doc/api-reference/widgets/infinite-hits/js/#widget-param-cache
                // We provide another implementation which uses sessionStorage, which is more persistent and lets you restore the scroll position when you leave and come back to the search page.
                // cache: createInfiniteHitsSessionStorageCache(),
            }),
            instantsearchWidgets.refinementList({
                container: '#algolia-refinement-list',
                attribute: 'objectGroupID', // objectClassName
                transformItems: function(items) {

                    // For objectGroupID
                    const newItems = items.map(item => {
                        let name = item.value;
                        const group = algoliaObjectGroups.find(group => group.id === item.value);
                        if (group) {
                            name = group.titlePlural;
                        } else {
                            name = name.replace('_', ' ');
                            if (name.charAt(name.length - 1) != 's') name += 's';
                        }

                        item.label = name;
                        item.highlighted = name;

                        return item;
                    });

                    // For objectClassName
                    // const newItems = items.map(item => {
                    //     let name = item.value;
                    //     const label = labels.find(label => label.className === item.value);
                    //     if (label) {
                    //         name = label.title;
                    //     } else {
                    //         const classNameSplit = item.label.split('\\');
                    //         if (classNameSplit.length) {
                    //             name = classNameSplit[classNameSplit.length-1];
                    //             if (name.charAt(name.length - 1) != 's') name += 's';
                    //             name = name.match(/[A-Z][a-z]+/g).join(' ');
                    //         }
                    //     }
                    //
                    //     item.label = name;
                    //     item.highlighted = name;
                    //
                    //     return item;
                    // });

                    return newItems;
                },
            }),
            instantsearchWidgets.stats({
                container: '#algolia-stats',
                templates: {
                    text: hpaTranslatedtext.algoliaSearch.stats.resultsForQuery, // {{nbHits}} results for "{{query}}"
                },
            }),
            // instantsearchWidgets.sortBy({
            //     container: '#algolia-sortby',
            //     items: [
            //         { label: hpaTranslatedtext.algoliaSearch.sortBy.mostRelevant /* Most Relevant */, value: indexName },
            //         { label: hpaTranslatedtext.algoliaSearch.sortBy.recentlyAdded /* Recently Added */, value: indexName + '_SortByCreatedDesc2' },
            //         // { label: hpaTranslatedtext.algoliaSearch.sortBy.titleAsc /* Title (a -> z) */, value: indexName + '_SortByTitleAsc' },
            //         // { label: hpaTranslatedtext.algoliaSearch.sortBy.titleDesc /* Title (z -> a) */, value: indexName + '_SortByTitleDesc' },
            //     ],
            // }),
        ]);

        searchResultsInstantSearch.start();
    }

    $('body').on('click', '.algolia-object', function() {
        const $this = $(this);

        hpaAlgoliaEvent({
            EventType: 'click',
            EventName: 'Search Result Click',
            EventMsTimestamp: Date.now(),
            ObjectIDs: $this.data('object-id'),
            QueryID: $this.data('query-id'),
            Positions: $this.data('position')
        });
    });

});



// WEBPACK FOOTER //
// ./js/modules/algoliaSearch.js